import { createSelector } from '@reduxjs/toolkit';
import type { RootState } from './index';

export const selectMessages = (state: RootState) => state.agentChat.messages;
export const selectIsLoading = (state: RootState) => state.agentChat.isLoading;
export const selectError = (state: RootState) => state.agentChat.error;
export const selectStreamingStatus = (state: RootState) => state.agentChat.streamingStatus;
export const selectCurrentToolName = (state: RootState) => state.agentChat.currentToolName;
export const selectProgressMessage = (state: RootState) => state.agentChat.progressMessage;
export const selectApprovalRequest = (state: RootState) => state.agentChat.approvalRequest;
export const selectThreadId = (state: RootState) => state.agentChat.threadId;
export const selectSkipTypewriter = (state: RootState) => state.agentChat.skipTypewriter;

export const selectHasMessages = createSelector(
  selectMessages,
  selectIsLoading,
  (messages, isLoading) => messages.length > 0 || isLoading,
);
